<template>
  <div class="parent_cast_cont_">
    <div
      class="cast_header flex justify-between items-center w-full h-16 px-4 py-2 z-5 sticky top-0"
    >
      <p class="text-xl font-bold">/cast.details</p>
      <p class="text-red font-bold" v-if="selectedCastId.is_running === 'true'">
        <span class="font-bold text-4xl">.</span> LIVE
      </p>
      <button
        class="redi_btn"
        v-if="selectedCastId.isNftGated"
        @click="goToEventPage"
      >
        Event page ↗️
      </button>
    </div>

    <div class="flex flex-col gap-4 text-lg pt-6">
      <h1 class="text-xl font-bold" style="color: #545454 !important">
        C:\{{ activeUserInfo.firstName }}\cast.name >
        <span style="color: #22c55e !important">{{
          selectedCastId.event_name
        }}</span>
      </h1>
      <p class="basic_detail_cont_">
        >> Cast Type >
        <span class="text-white">{{ selectedCastId.cast_type }}</span>
      </p>
      <p class="basic_detail_cont_">
        >> Total Attendees >
        <span class="text-white">{{ selectedCastId.invitee_list.length }}</span>
      </p>
      <p class="basic_detail_cont_">
        >> Scheduled Date > <span class="text-white">{{ convertedDate }}</span>
      </p>
      <p class="basic_detail_cont_">
        >> Scheduled Time > <span class="text-white">{{ convertedTime }}</span>
      </p>
      <p class="basic_detail_cont_">
        >> NFT Drop >
        <span class="text-white">{{
          selectedCastId.nft_details_submitted
        }}</span>
      </p>
      <p class="basic_detail_cont_">
        >> NFT Gating >
        <span class="text-white">{{ selectedCastId.isNftGated }}</span>
      </p>
      <p class="basic_detail_cont_">
        >> Live Casting >
        <span class="text-white">{{ selectedCastId.is_running }}</span>
      </p>
      <p class="basic_detail_cont_">
        >> Selected Storage >
        <span class="text-white">{{
          selectedCastId.storageDetails
            ? selectedCastId.storageDetails.name
            : 'null'
        }}</span>
      </p>
    </div>

    <SessionsList :meeting-id="meetingSlug" @play-recording="onPlayRecording" />
  </div>
</template>

<script>
import moment from 'moment-timezone';
import SessionsList from '@/views/new-dashboard/components/SessionsList.vue';

export default {
  name: 'DecastDetails',
  components: { SessionsList },
  props: ['selectedCastId', 'firstCastId'],
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    meetingSlug() {
      return (
        (this.selectedCastId && this.selectedCastId.public_meeting_id) || ''
      );
    },
    convertedDate() {
      if (!this.selectedCastId?.event_date || !this.selectedCastId?.event_time)
        return '';
      return moment
        .utc(
          `${this.selectedCastId.event_date}T${this.selectedCastId.event_time}`
        )
        .local()
        .format('DD/MM/YYYY');
    },
    convertedTime() {
      if (!this.selectedCastId?.event_date || !this.selectedCastId?.event_time)
        return '';
      const utcDateTime = moment.utc(
        `${this.selectedCastId.event_date}T${this.selectedCastId.event_time}`
      );
      return utcDateTime.tz(moment.tz.guess()).format('hh:mm:ss A z'); // 12hr format + AM/PM + timezone
    },
  },
  methods: {
    goToEventPage() {
      const url = `${this.$globals.clientDomain}/cast/nft-gated/${this.selectedCastId.public_meeting_id}`;
      window.open(url, '_blank');
    },
    onPlayRecording(recording) {
      this.$emit('play-recording', recording);
    },
  },
  mounted() {
    this.selectedCastId = this.firstCastId;
  },
};
</script>

<style scoped>
* {
  font-family: 'JetBrains Mono', monospace !important;
}

.cast_header {
  background-color: #272727;
}

.basic_detail_cont_ {
  color: #545454;
}

.parent_cast_cont_ {
  overflow: scroll;
}

.redi_btn {
  background-color: transparent;
  outline: none;
  border: none;
  color: violet;
  font-size: 16px;
  cursor: pointer;
}
</style>
